import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Auth } from '@seeneco-ui/business';
import { ErrorBoundary } from '@seeneco-ui/core';

import { getAuthParams } from '@config';
import {
	appPageRoutes,
	filterRoutes,
	BASE_URL,
} from './urls';
import { PartnersEntry } from '@partners';


const { provider, businessService, systemName } = getAuthParams();
const components = {
	'leads': PartnersEntry,
	'login': () =>
		<Auth.AuthForm
			loginTitle='Для входа в личный кабинет партнёра введите логин и пароль Seeneco'
			registrationTitle='Для регистрации в личном кабинете партнёра заполните следующие поля'
			provider={provider}
			businessService={businessService}
			systemName={systemName}
			tariffCode='PARTNER_INFORMING'
			postActionURL={`${BASE_URL}/`}
		/>,
};

const AppRoute: React.FC<any> = (props) => {
	const { title, path, sysName } = props;
	const Component = components[sysName] || null;

	document.title = title || document.title;

	return (
		<Route
			path={path}
			render={() => (
				<ErrorBoundary>
					<Component />
				</ErrorBoundary>
			)}
		/>
	);
}

const Routing: React.SFC<any> = () => {
	const { isAuthorized } = Auth.useAuthContext();
	const availableRoutes = filterRoutes([], [], appPageRoutes, isAuthorized, false);
	const [firstRoute] = availableRoutes;

	return (
		<Switch>
			{
				availableRoutes.map(route => (
					<AppRoute
						key={route.sysName}
						title={route.title}
						path={route.path}
						sysName={route.sysName}
					/>
				))
			}
			<Redirect to={firstRoute.path} />
		</Switch>
	);
}

export {
	Routing,
};
